module.exports = __webpack_public_path__ + "static/media/cert_64.5332ab04.jpg";